import React from 'react';
import { Dropdown, Tooltip } from 'antd';
import { MoreOutlined, CopyOutlined } from '@ant-design/icons';
import StatusBadge from '@/components/ui/StatusBadge';
import Link from '@/components/ui/Link';

export const getAttendanceColumns = ({
    handleCopyEmail,
    openEditModal,
    onConfirmDelete,
    canUpdate,
    canDelete,
}) => [
    {
        title: 'Employee',
        key: 'employee',
        render: (_, record) => {
            const name = record.userName || '—';
            const email = record.userEmail;
            if (!email || email === '—') return name;
            return (
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <span style={{ fontWeight: 500, color: 'var(--ant-color-text, #000)' }}>{name}</span>
                    <span style={{ fontSize: '12px', display: 'inline-flex', alignItems: 'center', gap: '6px' }} onClick={(e) => e.stopPropagation()}>
                        <Link href={`mailto:${email}`}>{email}</Link>
                        <Tooltip title="Copy email">
                            <CopyOutlined
                                style={{ cursor: 'pointer', color: 'var(--ant-color-text-tertiary)', fontSize: 13 }}
                                onClick={(e) => handleCopyEmail(email, e)}
                            />
                        </Tooltip>
                    </span>
                </div>
            );
        },
    },
    {
        title: 'Date',
        dataIndex: 'date',
        key: 'date',
        width: 110,
        render: (val) => (val ? String(val).slice(0, 10) : '—'),
    },
    {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        width: 100,
        render: (val) => <StatusBadge status={val} />,
    },
    {
        title: 'Check In',
        dataIndex: 'checkIn',
        key: 'checkIn',
        width: 100,
        render: (val) => val || '—',
    },
    {
        title: 'Check Out',
        dataIndex: 'checkOut',
        key: 'checkOut',
        width: 100,
        render: (val) => val || '—',
    },
    {
        title: 'Action',
        key: 'action',
        width: 72,
        render: (_, record) => {
            const items = [];
            if (canUpdate) items.push({ key: 'edit', label: 'Edit' });
            if (canDelete) items.push({ key: 'delete', label: 'Clear Record', danger: true });
            if (items.length === 0) return null;
            return (
                <span onClick={(e) => e.stopPropagation()}>
                    <Dropdown
                        menu={{
                            items,
                            onClick: ({ key }) => {
                                if (key === 'edit') openEditModal(record);
                                if (key === 'delete') onConfirmDelete(record);
                            },
                        }}
                        trigger={['click']}
                    >
                        <MoreOutlined style={{ cursor: 'pointer', fontSize: 18 }} />
                    </Dropdown>
                </span>
            );
        },
    },
];
